import { render, staticRenderFns } from "./userLayout.vue?vue&type=template&id=3006f260&scoped=true"
import script from "./userLayout.vue?vue&type=script&lang=js"
export * from "./userLayout.vue?vue&type=script&lang=js"
import style0 from "./userLayout.vue?vue&type=style&index=0&id=3006f260&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3006f260",
  null
  
)

export default component.exports